import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'
import { defineAsyncComponent, type App } from 'vue'

// import.meta.glob replaces webpack's require.context (lazy by default) and
// keeps the './path/File.vue' key shape, so the derived PascalCase global
// names (e.g. core/AppBar.vue -> CoreAppBar) are unchanged.
const requireComponent = import.meta.glob('./**/*.vue')

// Registers EVERY .vue file under src/components globally and lazily.
// Called from main.ts on the app instance (replaces the Vue 2
// `Vue.component(name, asyncFactory)` side-effect module).
export function registerGlobalComponents(app: App) {
  Object.keys(requireComponent).forEach((fileName) => {
    const componentName = upperFirst(
      camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')),
    )

    app.component(componentName, defineAsyncComponent(() =>
      requireComponent[fileName]().then((componentConfig: any) => componentConfig.default || componentConfig) as any,
    ))
  })
}
